import { render, staticRenderFns } from "./_kpi.vue?vue&type=template&id=670ecb7a&"
import script from "./_kpi.vue?vue&type=script&lang=ts&"
export * from "./_kpi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670ecb7a')) {
      api.createRecord('670ecb7a', component.options)
    } else {
      api.reload('670ecb7a', component.options)
    }
    module.hot.accept("./_kpi.vue?vue&type=template&id=670ecb7a&", function () {
      api.rerender('670ecb7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_showcase/molecules/_kpi.vue"
export default component.exports